import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from '../ErrorPage';
import { SUPPORT_EMAIL } from '../../actions/urls';
import Raven from '../../sentry';

import './ErrorPage.css';

const debug = require('debug')('ErrorBoundary');

export const withErrorBoundary = (Comp, pageHeading) => props => (
  <ErrorBoundary
    pageHeading={pageHeading}
  >
    <Comp {...props} />
  </ErrorBoundary>
);

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false,
      errorMsg: '',
    };
  }

  componentDidCatch(error, info) {
    try {
      this.setState({
        showError: true,
        errorMsg: (
          <div>
            <div styleName="errorMessage">
              Unfortunately, My IPO encountered an error. Please try again or &nbsp;<a styleName="errorLink" href={`mailto:${SUPPORT_EMAIL}`}>click here to contact support.</a>&nbsp;
            </div>
            <br />
            <div styleName="errorDetails">
              Error details:
            </div>
            <br />
            <div styleName="errorDetails">
              {error.message}
            </div>
          </div>),
      });
      if (Raven) {
        // https://docs.sentry.io/clients/javascript/integrations/react/
        Raven.captureException(error, { extra: info });
      }
    } catch (err) {
      debug(`Error in ErrorBoundary componentDidCatch: ${err}`);
    }
  }

  render() {
    try {
      const {
        showError,
        errorMsg,
      } = this.state;
      const {
        pageHeading,
      } = this.props;
      if (showError) {
        return (<ErrorPage
          message={errorMsg}
          backTo="/"
          backLabel="Home"
          pageHeading={pageHeading}
        />);
      }
      return this.props.children;
    } catch (error) {
      debug(`Error in ErrorBoundary render: ${error}`);
      return null;
    }
  }
}

ErrorPage.propTypes = {
  pageHeading: PropTypes.string,
};

ErrorPage.defaultProps = {
  pageHeading: 'My IPO Encountered an Error',
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorPage/ErrorBoundary.js